import { MULTIFORM } from "./constants/specialContentTypes";

const getExplorerfsFiles = (data) => ({
  method: "GET",
  url: "/explorerfs/list",
  data,
});

const readExplorerfsIntegration = (data) => ({
  method: "GET",
  url: "/integrations",
  data,
});

const getExplorerfsIntegrations = (data) => ({
  method: "GET",
  url: "/integrations",
  data,
});

const readExplorerFsFiles = (data) => ({
  method: "GET",
  url: "/explorerfs/read",
  data,
  // options: { responseType: "blob" },
});

const deleteExplorerFsFiles = (data) => ({
  method: "DELETE",
  url: "/explorerfs/delete",
  data,
});

export const uploadExplorerFsFiles = ({ onUploadProgress, formData }) => ({
  method: "POST",
  url: "/explorerfs/upload",
  data: formData,
  headers: { ...MULTIFORM },
  options: { keepItRaw: true, onUploadProgress },
});

export const explorerFsApi = {
  getExplorerfsFiles,
  readExplorerfsIntegration,
  getExplorerfsIntegrations,
  readExplorerFsFiles,
  deleteExplorerFsFiles,
  uploadExplorerFsFiles,
};
